<template>
  <el-dialog
    width="1260px"
    :center="true"
    :show-close="true"
    :visible.sync="visiable"
    :close-on-click-modal="false"
    top="10vh"
  >
    <div slot="title">
      <div style="font-size: 18px; margin-bottom: 4px">{{ item[1] }}</div>
      <div style="font-size: 16px">{{ item[3] }}</div>
    </div>
    <div style="display: flex; justify-content: space-between">
      <el-form :model="param" :inline="true" size="mini">
        <el-form-item label="项目编号">
          <el-input
            v-model="param.projectCode"
            placeholder="请输入..."
            :maxlength="50"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input
            v-model="param.projectName"
            placeholder="请输入..."
            :maxlength="50"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="param.associatedStatus"
            filterable
            placeholder="请选择..."
          >
            <el-option label="全部" :value="null"></el-option>
            <el-option label="生效中" value="1"></el-option>
            <el-option label="已失效" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="submitForm()" size="mini"
          >筛选</el-button
        >
      </el-form>
      <div>
        <el-button
          type="primary"
          @click="add()"
          size="mini"
          style="padding-left: 20px; padding-right: 20px"
          icon="el-icon-plus"
        >
          新增</el-button
        >
      </div>
    </div>
    <div class="tableBody">
      <el-table
        v-loading="listLoading"
        class="limitManagerTable table-expand"
        style="width: 100%"
        :data="tableData"
        size="mini"
        border
        header-row-class-name="table-header"
      >
        <el-table-column
          width="50"
          type="index"
          label="#"
          align="center"
        ></el-table-column>
        <el-table-column
          minWidth="200"
          prop="[2]"
          label="项目编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="[3]"
          minWidth="200"
          label="项目名称"
          align="center"
        ></el-table-column>
        <el-table-column
          width="120"
          prop="[4]"
          label="项目开始日期"
          align="center"
        ></el-table-column>
        <el-table-column
          width="120"
          prop="[5]"
          label="项目结束日期"
          align="center"
        ></el-table-column>
        <el-table-column width="100" label="状态" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row[6] == 1" style="color: #66cc33">关联中</div>
            <div v-if="scope.row[6] == 2">取消关联</div>
          </template>
        </el-table-column>
        <el-table-column
          width="140"
          prop="[7]"
          label="操作人"
          align="center"
        ></el-table-column>
        <el-table-column width="140" prop="[8]" label="更新时间" align="center">
          <template slot-scope="scope">
            <span>{{ computedTime(scope.row[8]) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope" v-if="scope.row[6] == 1">
            <el-button type="text" size="small" @click="disassociate(scope.row)"
              ><span style="color: #f56c6c">取消关联</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination table-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="formData.pageSize"
        layout="slot,sizes, total,  prev, pager, next, jumper"
        :total="formData.total"
      >
      </el-pagination>
    </div>
    <Add ref="Add" @done="addDone" />
  </el-dialog>
</template>
<script>
import Add from "./Add.vue";
import utils from "@/common/js/util.js";
import moment from "moment";

export default {
  components: { Add },
  data() {
    return {
      allCustomers: [], //项目列表数组
      //筛选项参数
      param: {},
      param2: {},
      //表单翻页
      formData: {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null,
      },
      tableData: [], //表单信息
      listLoading: false,
      item: {},
      visiable: false,
    };
  },
  methods: {
    show(item) {
      this.param = {};
      this.param2 = {};
      this.item = item;
      this.formData = {
        storeCode: null,
        storeName: null,
        pageNo: 1,
        pageSize: 10,
        total: null,
      };
      this.visiable = true;
      this.getData();
    },
    //工具类，错误提示框
    myNotify(_this, type, normal, or) {
      utils.myNotify(_this, type, normal, or);
    },
    computedTime(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    //提交表单（筛选功能）
    submitForm() {
      this.param2 = JSON.parse(JSON.stringify(this.param));
      this.formData.pageNo = 1;
      this.getData();
    },
    //翻页
    handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },
    //获取数据
    getData() {
      this.listLoading = true;
      let params = {
        customerMappingId: this.item[0],
        ...this.param2,
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo,
      };
      //获取表单数据
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/LongPromotionContractProject/projectMaintenance",
        params: params,
      })
        .then((res) => {
          this.tableData = res.data.items;
          this.formData.total = res.data.totalItemsCount;
          this.listLoading = false;
        })
        .catch((err) => {
          this.listLoading = false;
          this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    // 取消关联
    disassociate(item) {
      this.$confirm(
        `是否取消项目<span style="color:#ff4d4f">${item[3]}</span>与<span style="color:#ff4d4f">${this.item[1]}</span>的关联？`,
        "提示",
        {
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        }
      ).then(() => {
        this.$http({
          method: "GET",
          url: "/rest/LongPromotionContractProject/updateAssociatedStatus",
          params: {
            customerMappingId: this.item[0],
            id: item[0],
            operatorId: sessionStorage.getItem("sysUserId"),
          },
        }).then(({ data }) => {
          if (data.status == 200) {
            this.$emit("done");
            this.getData();
          } else {
            this.myNotify(this, "error", data.message);
          }
        });
      });
    },
    //新增
    add() {
      this.$refs.Add.show(this.item);
    },
    addDone() {
      this.$emit("done");
      this.formData.pageNo = 1;
      this.getData();
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tableBody {
  min-height: 525px;
}
</style>


// WEBPACK FOOTER //
// src/views/personnelCenter/customerProject/Project.vue